import { type TypographyColor } from "@octopus-energy/coral/atoms"
import { type SbLegacyTypographyColor } from "../types"

export const LEGACY_TYPOGRAPHY_COLOR_MAP: Record<SbLegacyTypographyColor, TypographyColor> = {
    ice: "base100",
    voltage: "tertiary500",
} as const
